import * as React from "react";
import { Datagrid, ExportButton, List, ReferenceField, TextField, TopToolbar } from "react-admin";
import { ExcelExport } from "../../../Helper/ExportExcel";
import { CustomDateField } from "../../../Components/CustomDateField";

const CockpitServiceableReturnViewList = props => {
  const cdmCategoryServiceEndpoint = "cdmservicelevel";

  const ListActions = props => (
    <TopToolbar {...props}>
      <ExportButton {...props} maxResults={99999} />
    </TopToolbar>
  );

  const exporter = (records, fetchRelatedRecords) => {
    // will call dataProvider.getMany('cdmaircrafts', { ids: records.map(record => record.aircraftId) }), ignoring duplicate and empty aircraftId
    fetchRelatedRecords(records, "requirementCategory", cdmCategoryServiceEndpoint).then(serviceLevel => {
      const data = records.map(record => ({
        RefNo: record.refNo,
        Customer: record.customer,
        "Core Pn": record.unsvcPn,
        "Core Sn": record.unsvcSn,
        "Requirement Category": serviceLevel[record.requirementCategory]?.category,
        // 'Is Serviceable Return': record.isServiceableReturn,
        "Request Date": record.createdDate,
        "Requested Delivery Date": record.requestedDeliveryDate,
      }));

      const columns = Object.keys(data[0]).map(record => ({ header: record }));

      ExcelExport(columns, data, "Serviceable Return List");
    });
  };

  return (
    <List
      {...props}
      filterDefaultValues={props.filterParams}
      actions={<ListActions />}
      exporter={exporter}
      bulkActionButtons={false}
      filter={{ isServiceableReturn: false }}
    >
      <Datagrid>
        <TextField source="refNo" label={"Ref No"}/>
        <TextField source="customer" label={"Customer"}/>
        <TextField source="unsvcPn" label={"Core PN"}/>
        <TextField source="unsvcSn" label={"Core SN"}/>
        <ReferenceField
          label="Requirement category"
          source="requirementCategory"
          reference={cdmCategoryServiceEndpoint}
          link={false}
        >
          <TextField source="category" />
        </ReferenceField>
        {/* <BooleanField source="isServiceableReturn" /> */}
        <CustomDateField source="createdDate" label="Request date" showTime />
        <CustomDateField source="requestedDeliveryDate" showTime />
      </Datagrid>
    </List>
  );
};

export default CockpitServiceableReturnViewList;
